/* eslint-disable no-unused-vars */
import React, { useState } from 'react';
import { Navigate } from 'react-router-dom';
import style from './login.module.scss';
import Logo from 'icons/logo';
import Typography from '@mui/material/Typography';
import FormControl from '@mui/material/FormControl';
import { useForm, FormProvider } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import FormCheckbox from 'controls/checkbox/formCheckbox';
import SubmitButton from 'controls/buttons/submit';
import Fields from './components/fields/fields';
import { Link } from 'react-router-dom';
import { AuthType, langs } from 'pages/login/types';
import { useAppDispatch } from 'store/hooks';
import {
  selectRememberMe,
  setRememberMe,
  signinRequest,
  signupRequest,
} from 'store/auth/authSlice';
import { useAppSelector } from 'store/hooks';
import { selectIsAuth, selectIsPending } from 'store/auth/authSlice';
import * as yup from 'yup';
import cx from 'classnames';

const normalizeEmail = (email: string) => {
  const trimmedEmail = email.trim();
  return trimmedEmail.toLowerCase();
};

const schemas = {
  signin: {
    email: yup.string().required('Поле не заполнено').email('Неверный формат'),
    password: yup.string().required('Поле не заполнено'),
  },
  signup: {
    email: yup.string().required('Поле не заполнено').email('Неверный формат'),
    password: yup
      .string()
      .required('Поле не заполнено')
      .min(8, 'Пароль должен содержать минимум 8 символов'),
    name: yup.string().required('Поле не заполнено'),
    surname: yup.string().required('Поле не заполнено'),
    organization: yup.string().required('Поле не заполнено'),
  },
};

export default function Login() {
  const isAuth = useAppSelector(selectIsAuth);
  const isAuthLoading = useAppSelector(selectIsPending);
  const rememberMe = useAppSelector(selectRememberMe);

  const [type, setType] = useState<AuthType>('signin');
  const dispatch = useAppDispatch();

  const toggleType = () => {
    setType(type === 'signin' ? 'signup' : 'signin');
  };

  const schema = yup.object({
    ...schemas[type],
  });

  const methods = useForm({
    resolver: yupResolver(schema),
    defaultValues: {
      email: '',
      password: '',
      name: '',
      surname: '',
      organization: '',
      remember_cbx: rememberMe,
    },
  });

  const onSubmit = (data: any) => {
    dispatch(setRememberMe(data.remember_cbx));
    switch (type) {
      case 'signin':
        dispatch(
          signinRequest({
            username: normalizeEmail(data.email),
            password: data.password,
          })
        );
        break;
      case 'signup':
        dispatch(
          signupRequest({
            email: data.email,
            name: data.name,
            organization: data.organization,
            password: data.password,
            surname: data.surname,
          })
        );
        break;
    }
  };

  return (
    <div className={cx(style.wrapper, 'adaptive-login__wrapper')}>
      {isAuth ? (
        <Navigate to="/" replace={true} />
      ) : (
        <div className={cx(style.container, 'adaptive-login__container')}>
          <Logo></Logo>
          <Typography className={style.header} variant={'h5'}>
            {langs[type].type}
          </Typography>
          <FormControl className={'adaptive-login__formControl'}>
            <FormProvider {...methods}>
              <form
                onSubmit={methods.handleSubmit(onSubmit)}
                className={'adaptive-login__form'}
              >
                <Fields type={type}></Fields>
                {type === 'signin' && (
                  <div className={style.help}>
                    <FormCheckbox
                      name="remember_cbx"
                      inner_props={{
                        form_control_label_props: {
                          label: 'Запомнить меня',
                        },
                        checkbox_props: {
                          checked: rememberMe,
                        },
                      }}
                    ></FormCheckbox>

                    <Link
                      className={cx(style['link-forget'], 'clickable-text')}
                      to="/password"
                    >
                      Забыли пароль?
                    </Link>
                  </div>
                )}
                <SubmitButton
                  gradiented={true}
                  wrapper={{
                    loading: isAuthLoading,
                    className: style.submit,
                  }}
                >
                  {!isAuthLoading && langs[type].main_action}
                </SubmitButton>
                <div className={style.footer}>
                  <span>{langs[type].existence_question}</span>
                  <span className={'link clickable-text'} onClick={toggleType}>
                    {langs[type].alternative_action}
                  </span>
                </div>
              </form>
            </FormProvider>
          </FormControl>
        </div>
      )}
    </div>
  );
}
